import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ConsultationFormBase from "./ConsultationFormBase";
import ResponseMessage from "../common/ResponseMessage";
import type { Consultation, PatientWithConstante } from "../../types";

const Registration: React.FC = () => {
  const navigate = useNavigate();
  const [responseMessage, setResponseMessage] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (_data: Consultation | PatientWithConstante) => {
    setIsSubmitting(true);
    setResponseMessage("");
    try {
      // No direct API call here; ConsultationFormBase handles submissions
      setResponseMessage("Consultation créée avec succès !");
      setTimeout(() => navigate("/admin/dashboard/patient"), 1500);
    } catch (err) {
      setResponseMessage("Erreur lors de la création de la consultation");
      console.error("Error creating consultation:", err);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-white to-slate-100 p-4">
      <ConsultationFormBase
        mode="create"
        onSubmit={handleSubmit}
        isSubmitting={isSubmitting}
        role="admin"
      />
      {responseMessage && <ResponseMessage message={responseMessage} role="admin" />}
    </div>
  );
};

export default Registration;
